import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Text from 'components/common/Text/Text'
import { LazyDiv } from 'components/common/LazyHtml'

const FeaturedBrands = ({ items }) =>
  items && items[0] && items[0].data ?
    <Wrapper>
      <Title headline centered>Featured Brands</Title>
      <BrandsWrapper>
        <Brands content={ items[0].data } />
      </BrandsWrapper>
    </Wrapper> :
    null

FeaturedBrands.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
}

FeaturedBrands.type = 'FeaturedBrands'

export default FeaturedBrands


const Wrapper = styled.div`
  padding: 37px 0 50px;
`

const Title = styled(Text)`
  margin-bottom: 30px;
  ${Media.mobile`
    font-size: 30px;
  `}
`

const BrandsWrapper = styled.div`
  text-align: center;
`

const Brands = styled(LazyDiv)`
  display: inline-block;
  text-align: left;
`
